<aaa-text size="caption2" display="flex" [color]="color" weight="semibold" [ngPlural]="numberReviews">
      {{ numberReviews | number }}
  <ng-template ngPluralCase="=1" i18n>review</ng-template>
  <ng-template ngPluralCase="other" i18n>reviews</ng-template>
</aaa-text>
